import React from 'react';
import {
    List,
    Datagrid,
    TextField, ReferenceField, Filter, TextInput, ReferenceInput, SelectInput,
} from 'react-admin';
import SgxDateField from '../components/sgxDateField';

const HistoricoFilter = props =>(
    <Filter {...props} >
        <TextInput source="id" />
        <ReferenceInput
            source="estado"
            reference="estado-validaciones"
            label="Estado"
        >
            <SelectInput optionText="descripcion" optionValue="id" />
        </ReferenceInput>
    </Filter>
);

const HistoricoValidacionesList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<HistoricoFilter/>}>
    <Datagrid rowClick="show">
        <TextField source="id" />
        <ReferenceField
            source="estado"
            reference="estado-validaciones"
            label="Estado"
        >
            <TextField source="descripcion" />
        </ReferenceField>
        <TextField source="numeroAfiliado"
                   label="resources.historico-validaciones.fields.numeroAfiliado"/>
        <ReferenceField
            source="idPrestacion"
            reference="prestaciones"
            label="resources.historico-validaciones.fields.prestacion"
        >
            <TextField source="descripcion"/>
        </ReferenceField>
        <SgxDateField source="fechaPrestacion" label="resources.historico-validaciones.fields.fechaPrestacion"/>
        <SgxDateField source="fechaSolicitud" label="resources.historico-validaciones.fields.createdOn"/>
    </Datagrid>
  </List>
);

export default HistoricoValidacionesList;
